module.exports = __webpack_public_path__ + "img/asset_scnSOL.0a818c2a.svg";